import CryptoJS from "crypto-js";

export function cryptoPassword(password) {
  const Salt = "6%dkszcU*&lk@#$T#(lknkj.359";

  const encryptedPassword = calcEncryptedPassword(password);

  return encryptedPassword;

  function calcEncryptedPassword(password) {
    if (!password || password.length <= 7) {
      console.log("Invalid input");
      return;
    }

    const payload = password + Salt;
    const len = payload.length;

    const a1 = payload.substring(0, 3);
    const a2 = payload.substring(3, len - 3);
    const a3 = payload.substring(len - 3);

    const encrypted = CryptoJS.MD5(a1 + a3 + a2);
    const encryptedPassword = encrypted.toString(CryptoJS.enc.Hex);

    return encryptedPassword;
  }
}

export function generateSignature(body) {
  const Salt = "6%dkszcU*&lk@#$T#(lknkj.359";

  const jsonBody = JSON.stringify(body);

  const signature = calcSignature(jsonBody);

  return signature;

  function calcSignature(s) {
    if (!s || s.length <= 20) {
      console.log("Invalid input");
      return;
    }

    const payload = s + Salt;
    const len = payload.length;

    const a1 = payload.substring(0, 10);
    const a2 = payload.substring(10, len - 10);
    const a3 = payload.substring(len - 10);

    const encrypted = CryptoJS.MD5(a1 + a3 + a2);
    const signature = encrypted.toString(CryptoJS.enc.Hex);

    return signature;
  }
}
